import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Document, Page, pdfjs } from "react-pdf";

// Set up worker
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const programs = [
  { label: "M.Ed.", file: "/MEd Afflication.pdf" },
  { label: "Integrated B.A. B.Ed / B.Sc. B.Ed", file: "" },
  { label: "ITEP (Foundation)", file: "/Ncte.pdf" } 
];

function CourseAffiliation() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const programQuery = searchParams.get("program");

  const [numPages, setNumPages] = useState(null);
  const [containerWidth, setContainerWidth] = useState(800);
  
  const initialProgram = programs.find(p => p.label === programQuery) || programs[0];
  const [selectedProgram, setSelectedProgram] = useState(initialProgram);

  useEffect(() => {
    if (programQuery) {
      const prog = programs.find(p => p.label === programQuery);
      if (prog) {
        setSelectedProgram(prog);
      }
    }
  }, [programQuery]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(() => {
    // Disable right click to completely prevent saving
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Responsive width handler
    const handleResize = () => {
      // 90% of window width on small screens, max 800px on large screens
      setContainerWidth(Math.min(window.innerWidth * 0.9, 800));
    };
    handleResize(); // initialize
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div style={{ width: "100%", padding: "2rem 1rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <h2 style={{ textAlign: "center", marginBottom: "1rem" }}>Course Recognition Details</h2>
      
      {/* Hide overflowing canvas to prevent horizontal scrollbars */}
      <style>{`
        .react-pdf__Page__canvas {
          margin: 0 auto;
          max-width: 100%;
          height: auto !important;
        }
      `}</style>
      
      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <h3 style={{ color: "#333" }}>{selectedProgram.label}</h3>
      </div>

      <div style={{ border: "1px solid #ccc", maxWidth: "100%", display: "flex", justifyContent: "center", minHeight: "200px", alignItems: "center" }}>
        {selectedProgram.file ? (
          <Document file={selectedProgram.file} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
              <div key={`page_${index + 1}`} style={{ marginBottom: "10px", display: "flex", justifyContent: "center" }}>
                <Page
                  pageNumber={index + 1}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  width={containerWidth}
                />
              </div>
            ))}
          </Document>
        ) : (
          <p style={{ color: "#666", padding: "2rem" }}>Document not available yet.</p>
        )}
      </div>
    </div>
  );
}

export default CourseAffiliation;
